// extracted by mini-css-extract-plugin
export default {"list":"AddDocument_list__fY0Gc","disabled":"AddDocument_disabled__kJ+ac","btn":"AddDocument_btn__gMYRP"};